/* eslint-disable react/prop-types */
import { Range, getTrackBackground } from 'react-range';

import useStyles from './styles';
import { IRangeInputProps } from './types';

const RangeInput = ({
  min,
  max,
  value,
  step,
  disabled,
  handler,
  finalHandler,
}: IRangeInputProps) => {
  const classes = useStyles({ disabled });

  return (
    <Range
      disabled={disabled}
      step={step}
      min={min}
      max={max}
      values={[value]}
      onFinalChange={(values) => finalHandler(Number(values[0]))}
      onChange={(values) => handler(Number(values[0]))}
      renderTrack={({ props, children }) => (
        <div
          onMouseDown={props.onMouseDown}
          onTouchStart={props.onTouchStart}
          className={classes.track}
        >
          <div
            ref={props.ref}
            className={classes.trackItem}
            style={{
              background: getTrackBackground({
                values: [value],
                colors: ['#C209C1', '#CCCCCC'],
                min: min,
                max: max,
              }),
              alignSelf: 'center',
            }}
          >
            {children}
          </div>
        </div>
      )}
      renderThumb={({ props }) => (
        <div className={classes.thumbContainer} {...props}>
          <div className={classes.thumb} />
        </div>
      )}
    />
  );
};

export default RangeInput;
